import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { NavLink, withRouter } from "react-router-dom"
//import { NavLink} from "react-router-dom";
import axios from 'axios'
import { connectNode } from '../../../../../utils/global'
import { escapeHtml } from '../../../../../utils/textFunctions'
import PostAddIcon from '@material-ui/icons/PostAdd'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import AddBoxIcon from '@material-ui/icons/AddBox'
import Button from '@material-ui/core/Button'
import Spinner from 'react-spinner-material'
import { loadLocationWithMessage } from '../../../../../actions/location'
import '../../../../../styles/assets/css/admin/list2.css'

import Accordion from '@material-ui/core/Accordion'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import WarningIcon from '@material-ui/icons/Warning'
import Pagination from '../../../../functions/pagination'
import { completion, treatment_targets, yes_no } from '../../variables/treatment_plan.js'
import ReactHtmlParser from 'react-html-parser'

class TreatmentPlanList extends Component {
  constructor() {
      super();
      this.state = {
          status: false,
          message: '',
          dataItems: [],
          pageOfItems: [],
          cnt_active: 0,
          treatmentGoal: [],
          todoList: [],
          p_status: 0,
          goal_completion_id: 0,
      }
      this.onChangePage = this.onChangePage.bind(this)
  }

  componentDidMount() {
    this.getData()
    //console.log(treatment_targets)
  }

  getData = () => {
    axios({
      method: 'post',
      url: connectNode + 'admin/treatment_plan/get_treatment_plan_overall_list2',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        pid: this.props.match.params.pid,
      }
    })
    .then((result) => {
      var treatmentGoal = []
      var p_status = ''
      var getData = []
      var dataItems = []
      var cnt = 0
      var todoList = []
      if(result['data'][0].status == "fulfilled") {
        treatmentGoal = result['data'][0].value
        p_status = result['data'][0].value.status
      }
      if(result['data'][1].status == "fulfilled") {
        getData = result['data'][1].value
        if(getData.length > 0) {
          getData.map(each => {
            if(each.completion == 2) {
              cnt++
            }
          })
          dataItems = getData
        }
      }
      if(result['data'][2].status == "fulfilled") {
        todoList = result['data'][2].value
      }
      this.setState({
        treatmentGoal: treatmentGoal,
        p_status: p_status,
        dataItems: dataItems,
        cnt_active: cnt,
        todoList: todoList,
      })
    })
    // get current treatment goal //
    /*axios({
      method: 'post',
      url: connectNode + 'admin/treatment_plan/get_current_treatment_goal',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: { pid: this.props.match.params.pid }
    })
    .then((result) => {
      //console.log(result['data'])
      if(result['data'] != 0) {
        this.setState({
          treatmentGoal: result['data'],
          p_status: result['data'][0].status
        })
      }
    })
    // get treatment plan list //
    axios({
      method: 'post',
      url: connectNode + 'admin/treatment_plan/get_treatment_plan_list',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: { pid: this.props.match.params.pid }
    })
    .then((result) => {
      //console.log(result['data'])
      var cnt = 0
      if(result['data'].length > 0) {
        result['data'].map(each => {
          if(each.completion == 2) {
            cnt++
          }
        })
        this.setState({
          dataItems: result['data'],
          cnt_active: cnt,
        })
      }
    })
    // get treatment to do list //
    axios({
      method: 'post',
      url: connectNode + 'admin/treatment_plan/get_treatment_active_todo_list',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: { pid: this.props.match.params.pid }
    })
    .then((result) => {
      //console.log(result['data'])
      this.setState({
        todoList: result['data'],
      })
    })*/
  }

  onChangePage(pageOfItems) {
    this.setState({ pageOfItems: pageOfItems })
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: escapeHtml(e.target.value),
      //uid: this.props.uid,
    })
  }

  findLabelByValue(arr, searchValue) {
    var label = ''
    var result = arr.find(obj => {
      return obj.value == searchValue
    })
    if(typeof result !== "undefined") {
      label = result.label
    }
    return label
  }

  getTodoListValue(arr, plan_id) {
    var txt = ''
    var buff = ''
    var sep = []
    var cnt_line = 0
    //console.log(arr)
    if(arr.length > 0) {
      arr.map(obj => {
        //console.log(obj)
        if(obj.todo_status != 1 && obj.todo_status != 3 && obj.plan_id == plan_id) {
          if(cnt_line > 0) {
            txt += "<br />"
          }
          txt += '- '+obj.intervention
          cnt_line++
        }
        /*if(obj.interventions && obj.plan_id == plan_id) {
          buff = obj.interventions
          sep = buff.split('|||')
          sep.map((each, index) => {
            buff = each.split('###')
            if(buff[1] != 1 && buff[1] != 3) {
              if(cnt_line > 0) {
                txt += "<br />"
              }
              txt += '- '+buff[0]
              cnt_line++
            }
          })
        }*/
      })
    }
    return txt
  }

  genTreatmentTarget2(arr, pid, tid) {
    var txt = ''
    if(arr) {
      var sep = arr.split(',')
      var sep2 = []
      var cnt_line = 0
      sep.map((each, index) => {
        sep2 = each.split('-')
        //console.log(sep[0] + ': ' + sep2[0] + ', ' + sep2[1])
        if(sep2[2] != 1 && sep2[1] != 1 && sep2[3] != 1 && sep2[3] != 3) {
          if(cnt_line > 0) {
            txt += "<br />"
          }
          txt += '- '+this.findLabelByValue(treatment_targets, sep2[0])
          if(sep2[1] == 1) {
            txt += ' [Full]'
          } else if(sep2[1] == 2) {
            txt += ' [Partial]'
          } else if(sep2[1] == 3) {
            txt += ' [None]'
          }
          cnt_line++
        }
      })
    }
    return txt
  }

  genTreatmentTarget(arr, pid, tid, plan_completion) {
    var txt = ''
    var target_list = []
    if(arr) {
      var sep = arr.split('|||')
      var sep2 = []
      var cnt_line = 0
      sep.map((each, index) => {
        sep2 = each.split('-')
        //console.log(sep[0] + ': ' + sep2[0] + ', ' + sep2[1])
        if(plan_completion != 1 && sep2[2] != 1 && sep2[1] != 1 ) { // && sep2[3] != 1 && sep2[3] != 3
          if(!target_list.includes(sep2[0])){
            target_list.push(sep2[0])
            if(cnt_line > 0) {
              txt += "<br />"
            }
            txt += '- '+this.findLabelByValue(treatment_targets, sep2[0])
            if(sep2[1] == 1) {
              txt += ' [Full]'
            } else if(sep2[1] == 2) {
              txt += ' [Partial]'
            } else if(sep2[1] == 3) {
              txt += ' [None]'
            }
            cnt_line++
          }
        }
      })
    }
    return txt
  }

  genNewTreatmentTarget(arr, pid, tid, completion) {
    var txt = ''
    if(arr) {
      var sep = arr.split(',')
      var sep2 = []
      var cnt_line = 0
      sep.map((each, index) => {
        sep2 = each.split('-')
        //console.log(sep[0] + ': ' + sep2[0] + ', ' + sep2[1])
        if(sep2[2] != 1 && sep2[1] != 1) {
          cnt_line++
        } else if(completion == 2) {
          cnt_line++
        }
      })
    }
    return cnt_line
  }

  handleUpdateStatus = (plan_id) => {
    document.getElementById('warning_box').style.display = 'block'
    this.setState({ goal_completion_id: plan_id })
    window.scrollTo(0, 0)
  }

  confirmUpdate = (e) => {
    var pid = this.props.match.params.pid
    axios({
      method: 'post',
      url: connectNode + 'admin/treatment_plan/edit_treatment_goal_completion',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        uid: this.props.authReducer.uid,
        //user: this.state,
        pid: pid,
        goal_completion_id: this.state.goal_completion_id,
      }
    })
    .then((result) => {
      //console.log(result)
      if(result['data'] === pid) {
        this.closeWarningBox()
        window.scrollTo(0, 0)
        this.getData()
      }
    })
  }

  closeWarningBox = (e) => {
    document.getElementById('warning_box').style.display = 'none'
  }

  render() {
    //console.log(this.state.todoList)
    return (
    <div className="admin_treatment_plan">
      <div className="row">
        <div className="small-9 columns title4">
          Treatment Plan
        </div>
        <div className="small-3 columns bold button_header2">
        {(this.state.treatmentGoal.length - this.state.dataItems.length) > 0 &&
          <NavLink to={'/admin/treatment_plan/new_treatment_plan/'+this.props.match.params.pid} className="menu_list_active">
            New Treatment Plan
          </NavLink>}
        </div>
      </div>
      <div className="row">
        <div className="small-12 columns ">
          { typeof this.props.locationReducer.txt_message !== 'undefined' &&
            this.props.locationReducer.txt_message !== "" &&
            <div className="row warning_msg7">
              <div className="small-12 columns ">
                <div className="float_left1"><CheckCircleOutlineIcon /></div>
                <div className="txt_warning_msg1">{ this.props.locationReducer.txt_message }</div>
              </div>
            </div>}
        </div>
      </div>
      <div className="row">
        <div className="small-12 columns">
        <table className="table_data1">
          <thead className="table_head">
            <tr>
              <th className="w_num">#</th>
              <th className="w_tt">Long-term Goal</th>
              <th className="w_st">History</th>
              <th className="w_tt">To Do List</th>
              <th className="w_st">Goal Completion</th>
              <th className="w_date">Date Created/Updated</th>
            </tr>
          </thead>
          <tbody>
        {!this.state.dataItems &&
          <tr>
            <td className="loading2"><Spinner color={"#bbbbbb"} radius={50}/></td>
          </tr>}
        {this.state && this.state.dataItems && this.state.pageOfItems.map((item, index) =>
          <tr key={'d'+index}>
            <td>{index+1}</td>
            <td>
              <a href={"/admin/treatment_plan/treatment_plan/"+item.pid+"/"+item.id}>
                {item.treatment_goal_id > 0 && item.tm_goal}
                {item.treatment_goal_id < 0 && item.treatment_goal_other}
              </a></td>
            <td><a href={"/admin/treatment_plan/treatment_plan_history_log/"+item.pid+"/"+item.id}>History</a></td>
            <td className="align_left">
            {ReactHtmlParser(this.getTodoListValue(this.state.todoList, item.id))}
            {item.completion == 2 &&
            <span><br />
              <a href={"/admin/treatment_plan/new_to_do_list/"+item.pid+"/"+item.id}><AddBoxIcon />To Do List</a>
            </span>}
            </td>
            <td>
            {item.completion == 2 && this.findLabelByValue(yes_no, item.completion)}
            {item.completion == 1 &&
              <a onClick={()=>this.handleUpdateStatus(item.id)}>
              {this.findLabelByValue(yes_no, item.completion)}</a>
            }
            </td>
            <td>{item.conv_created_date} / <br />{item.conv_updated_date}</td>
          </tr>
        )}
        {this.state && this.state.dataItems &&
          <tr className="pagination_block">
            <td colSpan="7">
              <Pagination items={this.state.dataItems} pageSize={20} onChangePage={this.onChangePage} />
            </td>
          </tr>
        }
        </tbody>
        </table>
        </div>
      </div>
      <div className="warning_box" id="warning_box">
        <div className="row">
          <div className="small-12 columns">
          <WarningIcon /> Are you sure you want to
          change this Long-term Goal to incomplete?
          </div>
          <div className="small-12 columns margin_top_space1">
          <Button variant="contained" color="primary" className="margin_right_1" disableElevation
           onClick={this.confirmUpdate} type="button">Yes</Button>
         <Button variant="contained" color="primary" disableElevation
          onClick={this.closeWarningBox} type="button">No</Button>
          </div>
        </div>
      </div>
    </div>)
  }
}

const mapStateToProps = (state) => {
  //console.log('Treatment Plan List STATE: ', state)
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    //console.log('AddPatient mapDispatchToProps')
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(TreatmentPlanList)
